export const COMMON_ROUTES = {
	COMMUNITY_NOT_FOUND: "/community-not-found",
} as const;
